module.exports = __webpack_public_path__ + "static/media/notification-icon.fb90cf7c.svg";